<template>
  <div>
    <deliver-apply v-show="active === 'query'" @changeActive="changeActive" />
    <to-goods v-if="active === 'toGoods'" :row-data="row" @back="back" />
  </div>
</template>

<script>
import DeliverApply from './components/DeliverApply.vue'
import ToGoods from './components/ToGoods.vue'
export default {
  components: {
    ToGoods,
    DeliverApply
  },
  data() {
    return {
      active: 'query',
      row: {}
    }
  },
  created() {
    if (this.$route.query?.active === 'toGoods') {
      this.active = this.$route.query.active
    }
  },
  methods: {
    changeActive(type, row) {
      this.active = type
      this.row = row
    },
    back() {
      if (this.$route.query?.id) {
        this.$router.back()
      } else {
        this.active = 'query'
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/apply-for-manage/business-processing/deliverApply.vue